import * as swcHelpers from '@swc/helpers';
import { GET_RETURN } from '../../../operations/queries/get-return.js';
import { mapFailures } from '../../../utils/map-failures.js';
import { mapReturn } from '../../../utils/map-return.js';

const getReturn = function() {
    var _ref = swcHelpers.asyncToGenerator(function*({ client , query  }) {
        try {
            var ref, ref1;
            const { data , error  } = yield client.query({
                query: GET_RETURN,
                variables: {
                    input: query.variables
                },
                context: {
                    forwardHeaders: {
                        'Accept-Language': query.locale
                    }
                },
                fetchPolicy: 'no-cache'
            });
            if (error) {
                console.error(error);
                throw new Error(error.message);
            }
            return {
                returnData: ((ref = data.getReturn) === null || ref === void 0 ? void 0 : ref.return) ? mapReturn(data.getReturn.return) : null,
                failures: ((ref1 = data.getReturn) === null || ref1 === void 0 ? void 0 : ref1.failures) ? mapFailures(data.getReturn.failures) : null
            };
        } catch (e) {
            console.error(`Failed to query return status: ${e}`);
        }
        return {
            returnData: null,
            failures: [
                'technicalError'
            ]
        };
    });
    return function getReturn(_) {
        return _ref.apply(this, arguments);
    };
}();

export { getReturn };
//# sourceMappingURL=get-return.js.map
